// A process-wide default compiler backend for the browser seams (LocalServer,
// ScriptTenant).
//
// Production leaves this UNSET and injects the WASM compiler explicitly — main.ts
// boots it once and threads it through the host + LocalHub. This holder exists
// only so web unit tests, which run under Node, can register the WASM compiler a
// single time in setup (test-setup.ts) instead of threading it through every one
// of the ~30 `LocalServer.create` / `new ScriptTenant` call sites.
//
// It is isomorphic (no node:fs) and safe in the browser bundle; if a real
// browser path ever reaches a seam without injecting a compiler, the seam throws
// rather than silently falling back — this only ever holds a value in tests.

import type { MunosCompiler } from "@multinostalgia/munos";

let current: MunosCompiler | undefined;

export function setDefaultCompiler(compiler: MunosCompiler | undefined): void {
  current = compiler;
}

export function defaultCompiler(): MunosCompiler | undefined {
  return current;
}
